export const enum TabEnum {
  News = 1,
  UrgnetAlerts = 2,
  OutOfStock = 3
}
 